export default __webpack_public_path__ + "static/media/sponsered1.75053d3202086b6c27cd24af835d1552.svg";